import { IoClose, IoPrint } from "react-icons/io5";
import { QurealViewer } from "qureal-editor";
import CuModal from "../../common_component/component/CuModal";
import { useState, useEffect, useRef } from "react";
import SharePrescription from "./SharePrescription";
import { useItemsFilterNew } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { useAtom } from "jotai";
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import CertificateViewer from "./CertificateViewer";
import ReactToPrint from "react-to-print";
import PrintCertificate from "../../certificate/components/PrintCertificate";

const CertificateView = ({ userDetails = [], closeCertificate }) => {
  const { role_id } = useCurrentRole();
  const [clinic_id] = useAtom(clinicAtom);

  const [selectedContent, setselectedContent] = useState(null);
  const [updatedContent, setUpdatedContent] = useState(null);
  const printRef = useRef(null); // Ref for the CertificateEditor for print

  const [doctor_seting] = useAtom(doctorSettingAtom);

  // console.log("CONTENT", content);

  const selectPageSize = "A4";

  const header_footer_setup_data =
    doctor_seting.header_footer_setup[selectPageSize];

  let patient_name = "";
  let email = "";
  let phone = "";

  // console.log(userDetails);
  // Extract patient details
  if (userDetails?.length > 0) {
    patient_name = userDetails[0]?.full_name;
    email = userDetails[0]?.email;
    phone = userDetails[0]?.phone;
  }

  const sendNotification = () => {};

  const { data: certificateData } = useItemsFilterNew(
    ApiEndPoint.CLINIC,
    `?doctor_id=${role_id}&action=getCertificate&clinic_id=${clinic_id.id}&backend=True`,
    role_id ? true : false
  );

  const onSelectCertificate = (e) => {
    const content = e.target.value;
    // console.log(selectedSlug);
    setselectedContent(content);
  };

  useEffect(() => {
    // console.log(certificateData);
    if (certificateData?.data?.length > 0) {
      setselectedContent(certificateData?.data[0]?.content);
    }
  }, [certificateData]);

  // console.log(selectedContent);

  return (
    <CuModal closeModal={closeCertificate}>
      <div className="pb-2 flex items-center justify-end gap-3">
        <select className="mr-1" onChange={onSelectCertificate}>
          {certificateData?.data?.map((data, idx) => {
            return (
              <option key={idx} value={data?.content}>
                {data?.name}
              </option>
            );
          })}
        </select>
        {/* Print Button */}
        <ReactToPrint
          trigger={() => (
            <IoPrint
              size={25}
              className="cursor-pointer"
              // onClick={closeCertificate}
            />
          )}
          content={() => printRef.current} // Print the CertificateEditor
          pageStyle={`
            @media print {
              body {
                font-family: 'Arial', sans-serif;
                -webkit-print-color-adjust: exact;
              }
              .ql-align-center { text-align: center; }
              .ql-align-right { text-align: right; }
              .ql-size-large { font-size: 18px; }
              .ql-size-huge { font-size: 24px; }
            }
          `}
        />

        <SharePrescription
          phone={phone}
          sendNotification={sendNotification}
          iconSize={20}
          position="bottom-right"
        />
        <IoClose
          size={25}
          className="cursor-pointer"
          onClick={closeCertificate}
        />
      </div>

      <CertificateViewer
        userDetails={userDetails[0]}
        content={selectedContent}
        style={{
          width: "900px",
          height: "85vh",
        }}
        setUpdatedContent={setUpdatedContent}
        header_footer_setup_data={
          doctor_seting.header_footer_setup[selectPageSize]
        }
      />

      {/* Print Certificate Component */}
      <div style={{ display: "none" }}>
        <PrintCertificate
          ref={printRef}
          header_footer_setup_data={
            doctor_seting.header_footer_setup[selectPageSize]
          }
          editorContent={updatedContent}
        />
      </div>
    </CuModal>
  );
};

export default CertificateView;
